import Axios from "../utils/axios";
import { IGroupMembership } from "../interfaces/models/IGroupMembership";

const axios = new Axios();

export const getGroupMembershipsByPersonId = async (
  personId: string,
): Promise<IGroupMembership[]> => {
  if (!personId) {
    return [];
  }

  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({
        personId: {
          value: personId,
          comparisonType: "EQUAL",
        },
      }),
    );

    const response = await axios.Get(`./groupMembership?${params.toString()}`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Error fetching group memberships:", error);
    return [];
  }
};
